import { adminFetch } from "./_client";
import type { NotificationPreviewResponse } from "./types";


export function previewNotificationDelivery(
  token: string,
  body: { userId: string; flowId: string; contextKey?: string },
) {
  return adminFetch<NotificationPreviewResponse>(
    "/admin/communications/flows/preview",
    token,
    { method: "POST", body: JSON.stringify(body) },
  );
}
